import { render, staticRenderFns } from "./SingleOrganization.vue?vue&type=template&id=702a1adc&scoped=true&"
import script from "./SingleOrganization.vue?vue&type=script&lang=js&"
export * from "./SingleOrganization.vue?vue&type=script&lang=js&"
import style0 from "./SingleOrganization.css?vue&type=style&index=0&id=702a1adc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702a1adc",
  null
  
)

export default component.exports